/*
 * Action Types
 */
export enum balanceTypes {
  GET_BALANCE_REQUEST = '@BALANCE/GET_BALANCE_REQUEST',
  GET_BALANCE_SUCCESS = '@BALANCE/GET_BALANCE_SUCCESS',
  GET_BALANCE_FAILURE = '@BALANCE/GET_BALANCE_FAILURE',

  WALLET_DEBIT_REQUEST = '@BALANCE/ WALLET_DEBIT_REQUEST',
  WALLET_DEBIT_SUCCESS = '@BALANCE/ WALLET_DEBIT_SUCCESS',
  WALLET_DEBIT_FAILURE = '@BALANCE/ WALLET_DEBIT_FAILURE',

  CHANGE_BALANCE_TYPE = '@trip/CHANGE_BALANCE_TYPE',
}

/*
 * Data types
 */
export interface balanceInterface {
  id: string;
  type: number;
  paymentType: string;
  usageType: string | null;
  line: string;
  prefix: string;
  color: string;
  dbd: string;
  lat: string;
  lng: string;
  benefit: string;
  exitTime: string | null;
  lineSectionName: string | null;
  carPrefix: string | null;
  createdAt: string;
  value: number;
  description: string;
  invoiceId: string;
  transactionId: string;
  lineSectionWay: string | null;
  previousBalance: number;
  currentBalance: number;
  walletChargeId: string;
}

export interface balanceTypeInterface {
  key: number;
  value: string;
}

/*
 * State type
 */
export interface balanceState {
  readonly balanceList: balanceInterface[];
  readonly totalCount: number;
  readonly loading: boolean;
  readonly balanceType: balanceTypeInterface[];
  readonly error: boolean;
}
